// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inputs[data-v-70a3fff2] {\n  width: 200px;\n}\n", ""]);
// Exports
module.exports = exports;
